import React from 'react';
import AuthFooter from './AuthFooter';

import {
  LoginContentWrapper,
  LoginPageContentWrapper,
  LoginPageWrapper,
} from './styles';
/**
 * A wrapper component for the authentication page.
 *
 * @param children - The content to be displayed on the authentication page.
 */
export const AuthPageWrapper = ({ children }: { children: JSX.Element }) => {
  return (
    <LoginPageWrapper>
      <LoginContentWrapper>
        <LoginPageContentWrapper>{children}</LoginPageContentWrapper>
      </LoginContentWrapper>
      <AuthFooter />
    </LoginPageWrapper>
  );
};
